<!-- <div class="receipt-container"> -->
  <!-- Grey Header Section -->
  <!-- <div class="receipt-header-grey">
    <div class="header-flex">
      <div class="header-logo-block">
        <img src="assets/images/edu-logo.svg" alt="Nevada Department of Education" class="logo" />
      </div>
      <div class="header-title-block">
        <div class="header-title">PAYMENT CONFIRMATION</div>
        <div class="header-date">Receipt Date: {{ receiptData?.transactionDate }}</div>
      </div>
    </div>
  </div> -->
  <!-- Receipt Details Section -->
  <!-- <div class="receipt-details">
    <div class="section-title">Receipt Details</div>
    <div class="details-table">
      <div class="details-row">
        <div class="details-label"><b>Applicant Name:</b></div>
        <div class="details-value">{{ receiptData?.applicantName }}</div>
        <div class="details-label"><b>Invoice Number:</b></div>
        <div class="details-value">{{ receiptData?.invoiceNumber }}</div>
      </div>
      <div class="details-row">
        <div class="details-label"><b>Application ID:</b></div>
        <div class="details-value">{{ receiptData?.strApplicationNumber }}</div>
        <div class="details-label"><b>Payment Method:</b></div>
        <div class="details-value">{{ receiptData?.paymentMethod }}</div>
      </div>
      <div class="details-row">
        <div class="details-label"><b>Reference Number:</b></div>
        <div class="details-value">{{ receiptData?.strPaymentTransactionId }}</div>
        <div class="details-label"><b>Transaction Date:</b></div>
        <div class="details-value">{{ receiptData?.transactionDate }}</div>
      </div>
      <div class="details-row" *ngIf="receiptData?.paymentAmount">
        <div class="details-label"><b>Payment Amount:</b></div>
        <div class="details-value">${{ receiptData?.paymentAmount }}</div>
      </div>
    </div>
  </div>
</div> -->

<div class="receipt-container">
  <!-- Header -->
  <div class="receipt-header-grey">
    <div class="header-flex">
      <img src="assets/images/edu-logo.svg" alt="Nevada Department of Education" class="logo" />
      <div class="header-title-block">
         <div class="header-title">{{ receiptTitle }}</div>

        <div class="header-date">Receipt Date: {{ receiptData?.receiptDate}}</div>
      </div>
    </div>
  </div>
  <!-- Details -->
  <div class="receipt-details">
    <div class="section-title">Receipt Details</div>
    <table class="details-table">
      <tr>
        <td class="details-row-cell"><span class="details-label">Applicant Name:</span> {{ receiptData?.applicantName }}</td>
        <td class="details-row-cell"><span class="details-label">Invoice Number:</span> {{ receiptData?.invoiceNumber}}</td>
      </tr>
      <tr>
        <td class="details-row-cell"><span class="details-label">Application ID:</span> {{ receiptData?.applicationId }}</td>
        <td class="details-row-cell"><span class="details-label">Payment Method:</span> {{ receiptData?.paymentMethod || 'Card' }}</td>
      </tr>
      <tr>
        <td class="details-row-cell"><span class="details-label">Reference Number:</span> {{ receiptData?.referenceNumber }}</td>
        <td class="details-row-cell"><span class="details-label">Transaction Date:</span> {{ receiptData?.transactionDate }}</td>
      </tr>
    </table>
    <!-- Fee Table -->
    <div class="fee-table-section">
      <table class="fee-table">
        <thead>
          <tr>
            <th style="text-align: center;">Description</th>
            <th style="text-align: center;">Qty</th>
            <th style="text-align: center;">Fee</th>
            <th style="text-align: center;">Amount</th>
          </tr>
        </thead>
        <tbody>
          <!-- Dynamic rows: Display grouped and sorted items from API -->
          <ng-container *ngIf="processedBreakdownItems && processedBreakdownItems.length > 0; else defaultRow">
            <tr *ngFor="let item of processedBreakdownItems">
              <td style="text-align: center;">{{ item.revenue_code_desc }}</td>
              <td style="text-align: center;">{{ item.quantity }}</td>
              <td style="text-align: center;">{{ isNegativeAmount(item.price) ? '-' : '' }}${{ formatAmount(item.price || '0') }}</td>
              <td style="text-align: center;">{{ isNegativeAmount(item.paid_amount) ? '-' : '' }}${{ formatAmount(item.paid_amount || '0') }}</td>
            </tr>
          </ng-container>
          <!-- Fallback: Show default row if API returns no breakdown data -->
          <ng-template #defaultRow>
            <tr>
              <td style="text-align: center;">{{ getDefaultDescription() }}</td>
              <td style="text-align: center;">1</td>
              <td style="text-align: center;">{{ receiptData?.paymentAmount }}</td>
              <td style="text-align: center;">{{ receiptData?.paymentAmount }}</td>
            </tr>
          </ng-template>
        </tbody>
        <tr class="spacer-row">
          <td colspan="4"></td>
        </tr>
        <tfoot>
          <tr class="fee-total-row">
            <td colspan="2" style="border: none; background: transparent;"></td>
            <td class="fee-total-label fee-total-bg">Total Amount</td>
            <td class="fee-total-amount fee-total-bg">${{ totalAmount }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <!-- Footer -->
    <div class="receipt-footer">
      <div>
        This document serves as an official payment receipt and was generated automatically.<br>
        Fees are non-refundable and payment does not guarantee license approval.<br>
        Nevada Department of Education<br>
        <a href="https://doe.nv.gov/educator-licensure" target="_blank">https://doe.nv.gov/educator-licensure</a>
      </div>
    </div>
  </div>
</div>